/**
 * Created by piotr.pozniak@thebeaverhead.com on 06/01/2019.
 */

import React, { useEffect, useMemo, useRef, useState } from "react";

import classnames from "classnames";
import classNames from "classnames";
import EventsCounter from "./EventsCounter";
import DetailedEventsCounter from "./DetailedEventsCounter";
import { formatEventTime } from "./EventNameWithTime";
import { PT } from "../../../../consts";
import { useAppStore } from "../../../../hooks/redux/app";
import PrivateEventBadge from "../PrivateEventBadge";
import { sortEventsWithAllDayFirst } from "../../../../helpers/calendar";
import { isSameDay } from "../../../../helpers/date";

/**
 *
 * @param props
 * @param {Date} props.day
 * @param {Object} props.events
 * @param {Date} props.selectedDay
 * @param {function} props.onSelectDay
 * @param {boolean} props.showPills
 * @param {boolean} props.isCompact
 * @param {boolean} props.showEventsCountTooltip
 * @param {boolean} props.showFullNamesTooltip
 * @param {boolean} props.pillOpensEventDetails
 * @param {boolean} props.useEventAccent
 * @param {boolean} props.showRecurring
 * @param {boolean} props.showFeatured
 * @param {boolean} props.embedded
 * @returns {React.JSX.Element}
 * @constructor
 */
const CalendarDay = (props) => {
  const [state, setState] = useState({
    selectedDay: new Date(),
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const height = containerRef.clientHeight;
    const width = containerRef.clientWidth;

    setState({ ...state, width, height });
  }, []);

  const containerRef = useRef("");

  const {
    events,
    day,
    showRecurring,
    showFeatured,
    isEventsLimited,
    limitedNumberOfEvents,
  } = props;
  const { app } = useAppStore();

  const isMobilePreview = app.previewType === PT.mobile;

  let groupedDayEvents = null;

  const dayEvents = events.collection
    .filter((e) => {
      return day.isBetween(
        new Date(e.start_time * 1000),
        new Date(e.end_time * 1000),
        "day"
      );
    })
    .sort(sortEventsWithAllDayFirst);

  if (dayEvents.length && !props.showPills) {
    groupedDayEvents =
      dayEvents.length > 5 ? (
        <span className="event-dot">
          <i
            data-et={dayEvents[0].name}
            title={dayEvents[0].name}
            style={{ backgroundColor: dayEvents[0].accentColor }}
          />
          <b>+ {dayEvents.length - 1} more</b>
        </span>
      ) : (
        <span className="event-dot">
          {dayEvents.map((evnt) => {
            const eventTitle = formatEventTime(evnt);
            console.log(evnt.accentColor);
            return (
              <i
                key={"ded-" + evnt.id}
                data-et={eventTitle}
                title={eventTitle}
                style={{ backgroundColor: evnt.accentColor }}
              />
            );
          })}
        </span>
      );
  }

  const dayEventsCounter = props.showEventsCountTooltip ? (
    <EventsCounter eventsCount={dayEvents.length} />
  ) : null;

  const dayEventsCounterDetailed = props.showFullNamesTooltip ? (
    <DetailedEventsCounter
      events={dayEvents}
      isLeft={[5, 6].indexOf(day.getDay()) >= 0}
      parentContainerWidth={state.width}
      parentContainerHeight={state.height}
      useEventAccent={props.useEventAccent}
    />
  ) : null;

  const label = (
    <span className="day-label" id={"mc-day-label-" + day.getDate()}>
      {day.getDate()}
    </span>
  );

  const classes = classnames("day", {
    "current-day": day.isSameDay(new Date()),
    selected: isSameDay(props.selectedDay, day),
    "has-pills": props.showPills,
  });

  let eventsListPills = null;

  const daysEventPills = useMemo(
    () =>
      isEventsLimited ? dayEvents.slice(0, limitedNumberOfEvents) : dayEvents,
    [dayEvents, isEventsLimited, limitedNumberOfEvents]
  );

  const eventPillClasses = classNames({
    "event-pill": true,
    "mobile-preview-event-pill": isMobilePreview,
  });

  if (props.showPills && daysEventPills.length) {
    eventsListPills =
      dayEvents.length > limitedNumberOfEvents ? (
        <React.Fragment>
          <span className={eventPillClasses}>
            {daysEventPills.map((i) => {
              const inlineStyles = {};

              if (props.useEventAccent && i.accentColor) {
                inlineStyles.backgroundColor = i.accentColor;
                // inlineStyles.color = i.fontColor;
              }
              // console.log(inlineStyles);

              const recurringBadge =
                showRecurring && i.recurrence_description ? (
                  <i className={"material-icons dce--event-badge-recurring"}>
                    autorenew
                  </i>
                ) : null;
              const featuredBadge =
                showFeatured && i.is_featured ? (
                  <i className={"material-icons dce--event-badge-featured"}>
                    star
                  </i>
                ) : null;

              const eventTitle = formatEventTime(i);

              const privateEventBadge =
                i.is_private * 1 == 1 && !props.embedded ? (
                  <PrivateEventBadge className={"dce--event-badge-featured"} />
                ) : null;

              return (
                <span
                  key={i.id}
                  data-et={eventTitle}
                  title={eventTitle}
                  // onClick={onClickMore(i)}
                  style={inlineStyles}
                >
                  {privateEventBadge}
                  {featuredBadge}
                  {recurringBadge}
                  {eventTitle}
                </span>
              );
            })}
            {dayEvents.length - limitedNumberOfEvents > 0 &&
              isEventsLimited && (
                <b
                  className={classnames({
                    extendable: props.pillOpensEventDetails,
                  })}
                >
                  +&nbsp;{dayEvents.length - limitedNumberOfEvents} More
                </b>
              )}
          </span>
        </React.Fragment>
      ) : (
        <span className="event-pill">
          {dayEvents.map((i) => {
            const inlineStyles = {};

            if (props.useEventAccent && i.accentColor) {
              inlineStyles.backgroundColor = i.accentColor;
              // inlineStyles.color = i.fontColor;
            }
            // console.log(inlineStyles);

            const eventTitle = formatEventTime(i);
            return (
              <span
                key={i.id}
                data-et={eventTitle}
                title={eventTitle}
                // onClick={onClickMore(i)}
                style={inlineStyles}
              >
                {eventTitle}
              </span>
            );
          })}
        </span>
      );
  }
  return (
    <td className={classes} onClick={props.onSelectDay(day)} ref={containerRef}>
      {label}
      {groupedDayEvents}

      {dayEventsCounter}
      {eventsListPills}
      {dayEventsCounterDetailed}
    </td>
  );
};

export default CalendarDay;
